angular
    .module('tradersyard')
    .factory('group-read-filter', [
        '$flex',
        function ($flex) {
            var tab,
                hash,
                filter = {
                    init: function () {
                        hash = $flex.$hash.get();

                        tab =
                            [
                                'timeline',
                                'participant',
                                'workshops',
                                'schedules',
                                'request',
                                'document',
                                'video',
                                'photo',
                                'signals',
                                'trade_sharing',
                                'analysis_sharing',
                            ].indexOf(hash) !== -1
                                ? hash
                                : 'timeline';

                        filter.set(tab);
                    },
                    is: function (name) {
                        return tab === name;
                    },
                    set: function (name) {
                        tab = name;

                        if (filter.on.change) filter.on.change();

                        $flex.$touch.make(name);

                        if ($flex.$hash.get() !== name) $flex.$hash.set(name);
                    },
                    tab: function () {
                        return tab;
                    },
                    on: {
                        change: undefined,
                    },
                };

            return filter;
        },
    ])
    .controller('group-read-ctrl', [
        '$scope',
        '$rootScope',
        'graph-group-factory',
        '$flex',
        'RequestManagerFactory',
        'group-read-filter',
        '$flex.scroll',
        '$rootScope',
        'GraphParticipantService',
        'GuidFactory',
        'WebSocket',
        '$flex.array',
        '$window',
        '$q',
        'updatesService',
        'graph-api-client',
        '$timeout',
        'PaginationFactory',
        'AuthService',
        'MeetingService',
        'InvitationService',
        '$uibModal',
        /**
         *
         * @param $scope
         * @param $rootScope
         * @param groupFactory
         * @param $flex
         * @param RequestManagerFactory
         * @param $filter
         * @param $scroll
         * @param $root
         * @param ParticipantService
         * @param GuidFactory
         * @param $socket
         * @param $array
         * @param $window
         * @param $q
         * @param $updates
         * @param $client
         * @param $timeout
         * @param $paginationFactory
         * @param Auth
         * @param MeetingService
         * @param InvitationService
         * @param {ng.ui.bootstrap.IModalService} $uibModal
         */
        function (
            $scope,
            $rootScope,
            groupFactory,
            $flex,
            RequestManagerFactory,
            $filter,
            $scroll,
            $root,
            ParticipantService,
            GuidFactory,
            $socket,
            $array,
            $window,
            $q,
            $updates,
            $client,
            $timeout,
            $paginationFactory,
            Auth,
            MeetingService,
            InvitationService,
            $uibModal
        ) {
            const ctrl = this;

            $scope.node = {};
            $scope.requests = 0;
            $scope.participantRole = undefined;
            $scope.adminRoles = ['owner', 'executive', 'presenter'];

            ctrl.openInviteModal = function openInviteModal() {
                const groupData = $scope.node;
                InvitationService.openInviteModalForSubGroup(groupData.id, groupData.parent_id);
            };

            $scope.setParticipantRole = function (role) {
                $scope.participantRole = !!role ? role : undefined;
                setTimeout(function () {
                    $rootScope.$broadcast('participant:role', role);
                });
            };

            $scope.userCanEditComment = function (node) {
                if (!Auth.isUserAuthenticated()) {
                    return false;
                }

                if (
                    node.photos.length <= 0 &&
                    node.videos.length <= 0 &&
                    node.documents.length <= 0 &&
                    node.owner.id === $rootScope.me.id
                ) {
                    return true;
                }

                return false;
            };

            $scope.userCanDeleteMessage = function (node) {
                if (!Auth.isUserAuthenticated()) {
                    return false;
                }

                if (node.owner.id === $rootScope.me.id || $scope.adminRoles.includes($scope.participantRole)) {
                    return true;
                }

                return false;
            };

            $scope.requestWebClientIframe = function () {
                MeetingService.triggerMeetingIframe('group', $scope.node.id);
            };

            $scope.openWebMetingPopUp = function () {
                $rootScope.$emit('openWebMetingPopUp');
            };

            $scope.reverseOrder = true;
            $scope.sortField = 'created_at';

            $scope.sortBy = function (sortField) {
                $scope.reverseOrder = $scope.sortField === sortField ? !$scope.reverseOrder : false;
                $scope.sortField = sortField;

                $scope.participants.SortQuery({
                    field: sortField,
                    sort: $scope.reverseOrder ? 'desc' : 'asc',
                });
            };

            $scope.downloadParticipantsLink = function () {
                var groupId = $scope.node.id;

                return '/group/' + groupId + '/participants/download';
            };

            angular.extend($scope, $flex.data);

            $scope.participants = ParticipantService.Get($scope.node.id, 'group');
            $scope.participants.Count = $scope.node.participants;

            groupFactory.queryRelatedProducts($scope.node.id).then(function (response) {
                $scope.relatedProducts = response.data.data;
            });

            var canceler = $q.defer();

            $socket.emit('join:group', [$scope.node.id]);

            $scope.filter = $filter;
            $scope.params = {
                timeline: {
                    page: 0,
                },
                // participants: {
                //     page: 0
                // },
                documents: {
                    page: 0,
                },
                photos: {
                    page: 0,
                },
                videos: {
                    page: 0,
                },
            };
            $scope.timeline = [];
            // $scope.participants = [];
            $scope.documents = [];
            $scope.posts = [];
            $scope.photos = [];
            $scope.videos = [];
            $scope.progress = {
                photos: [],
                videos: [],
                documents: [],
            };
            $scope.ownerId = $scope.node.owner.id;

            $scope.Request = RequestManagerFactory.Init($scope.node.id, 'group', $scope);
            $scope.Request.Count = $scope.requests;
            $scope.Guid = GuidFactory.Generate();

            $scope.Join = function (node) {
                $scope.participants.Join(node.id, $scope.Guid, function () {
                    $scope.node.participants = $scope.participants.Data;
                    $scope.node.im_participant = true;
                });
            };

            $scope.Leave = function (node) {
                // If there's a related subscription, it means we can't just leave the group.
                if (node.subscription ?? false) {
                    // Open a modal window that the user won't be able to close that easily.
                    const resolve = {
                        entry: () => 'group',
                        entryId: () => node.id,
                    };

                    const modal = $uibModal.open({ component: 'tyParticipantLeaveModal', resolve });

                    modal.result
                        .then(() => {
                            window.location.reload();
                        })
                        .catch(() => console.log('modal dismissed'));
                } else {
                    $scope.participants.Leave(node.id, $scope.Guid, function () {
                        $scope.node.participants = $scope.participants.Data;
                        $scope.node.im_participant = false;
                    });
                }
            };

            $root.$on('role-change', function (event, data) {
                window.location.reload();
            });

            $scope.assignRole = function (node) {
                $root.$broadcast('open:assign-role:dialog', {
                    node: node,
                    entry: { type: 'group', id: $scope.node.id },
                });
            };

            $scope.removeParticipant = function (node) {
                $rootScope.$broadcast('open:confirm-participant-remove:dialog', {
                    node: node,
                    service: $scope.participants,
                });
            };

            $scope.selectExpire = function (node) {
                $rootScope.$broadcast('open:select-participant-expire:dialog', {
                    node: node,
                    service: $scope.participants,
                });
            };

            $scope.cancelExpire = function (node) {
                $scope.participants.Expire(node.id, (node.expired_at = null));
            };

            $scope.openDocument = function (documentObj) {
                if (documentObj.type === 'text/plain') {
                    readTextFile(buildDocumentUrl(documentObj)).then(function (text) {
                        $rootScope.$broadcast('graph-modal-show', {
                            title: documentObj.name,
                            content: text,
                            type: documentObj.type,
                        });
                        setTimeout(function () {
                            //magic for modal open
                            var icon = document.querySelector('.icon');
                            icon.click();
                        }, 0);
                    });
                } else if (documentObj.type === 'application/pdf') {
                    $rootScope.$broadcast('graph-modal-show', { title: documentObj.name });
                    var documentContainer = document.querySelector('.document-container');

                    PDFObject.embed(buildDocumentUrl(documentObj), documentContainer);
                } else {
                    download(documentObj);
                }
            };

            function buildDocumentUrl(documentObj) {
                return location.origin + '/' + documentObj.base_path;
            }

            function readTextFile(filePath) {
                var txt = '';
                return new Promise(function (resolve) {
                    var xmlhttp = new XMLHttpRequest();
                    xmlhttp.onreadystatechange = function () {
                        if (xmlhttp.status === 200 && xmlhttp.readyState === 4) {
                            txt = xmlhttp.responseText;
                            resolve(txt);
                        }
                    };

                    xmlhttp.open('GET', filePath, true);
                    xmlhttp.send();
                });
            }

            function download(documentObj) {
                var link = document.createElement('a');
                link.download = documentObj.name;
                link.href = documentObj.source;
                link.click();
            }

            $scope.lockDocument = function (documentObj) {
                var groupId = $scope.node.id;
                $timeout(function () {
                    $client
                        .post('group/' + groupId + '/document/' + documentObj.id + '/lock')
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                documentObj.locked = true;
                                // $socket.emit('lock:document', [documentObj.id]);
                            }
                        });
                }, 10);
            };

            $scope.unlockDocument = function (documentObj) {
                var groupId = $scope.node.id;
                // document.getElementById('document-input-reupload').click();
                $timeout(function () {
                    $client
                        .post('group/' + groupId + '/document/' + documentObj.id + '/unlock')
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                documentObj.locked = false;
                                // $socket.emit('unlock:document', [documentObj.id]);
                            }
                        });
                }, 10);
            };

            $scope.downloadError = function () {
                $root.$broadcast('graph-modal-show', {
                    title: 'Error',
                    content: 'Sorry, you can`t not download this document. Try later.',
                });
            };

            $socket.on('document:lock', function (data) {
                if (data.place.name === 'group' && data.place.id == $scope.node.id) {
                    $scope.documents.forEach(function (document, docIndex) {
                        if (data.node.id === document.id && document.locked !== true) {
                            document.locked = true;
                        }
                    });
                }
            });

            $socket.on('document:unlock', function (data) {
                if (data.place.name === 'group' && data.place.id == $scope.node.id) {
                    $scope.documents.forEach(function (document, docIndex) {
                        if (data.node.id === document.id && document.locked === true) {
                            document.locked = false;
                        }
                    });
                }
            });

            $scope.$on('web-meeting:open', (event) => {
                $scope.webMeting = {
                    open: true,
                };

                setTimeout(() => {
                    // wait for the iframe to show, then scroll the window
                    const target = document.querySelector('#choop-iframe-target');
                    if (target) {
                        window.scrollTo({
                            top: target.getBoundingClientRect().top + window.scrollY,
                            behavior: 'smooth',
                        });
                    }
                }, 0);
            });

            $scope.request = function (node) {
                $scope.Request.Create(node.id, 'group', $scope.Guid, function () {
                    node.is_requested = true;
                    location.reload();
                });
            };

            $scope.openCheckoutModal = function (node, $request) {
                node.request_id = node.request_id ?? $request.id;
                node.is_requested = true;

                if (featureDisabled('paid-groups')) {
                    location.reload();
                    return; // feature is disabled, so don't show the modal
                }

                if (!node.is_paid) {
                    return;
                }

                const resolve = {
                    groupId: () => node.id,
                    joinRequestId: () => node.request_id ?? $request.id,
                    subscriptionPlan: () => node.subscription_plan,
                };

                // Open a modal window that the user won't be able to close that easily.
                $uibModal.open({ component: 'tyGroupCheckoutModal', resolve, backdrop: 'static', keyboard: false });
            };

            $scope.upload = {
                headerImage: uploadHeaderImage,
                error: function (error) {
                    $root.$broadcast('graph-modal-show', {
                        title: 'Error',
                        content: error,
                    });
                },
                photo: function (node) {
                    if ($scope.photo && $scope.form.photo.$valid === true) {
                        var photo = $scope.photo;
                        $scope.progress.photos.push({
                            name: photo.name,
                        });

                        groupFactory
                            .photos(node.id)
                            .upload({
                                name: $scope.photo.name,
                                photo: $scope.photo.base,
                            })
                            .then(function (response) {
                                $scope.progress.photos = $array.$splice(
                                    $scope.progress.photos,
                                    { name: photo.name },
                                    'name'
                                );

                                if (response.data.state === 0) {
                                    $scope.photos.unshift(response.data.data);
                                } else {
                                    $root.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.photo ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
                video: function (node) {
                    if ($scope.video && $scope.form.video.$valid === true) {
                        var fd = new FormData();
                        fd.append('video', $scope.video.file);
                        fd.append('name', $scope.video.name);

                        var video = $scope.video;
                        $scope.progress.videos.push({
                            name: video.name,
                        });

                        groupFactory
                            .videos(node.id)
                            .upload(fd, {
                                transformRequest: angular.identity,
                                headers: { 'Content-Type': undefined },
                            })
                            .then(function (response) {
                                $scope.progress.videos = $array.$splice(
                                    $scope.progress.videos,
                                    { name: video.name },
                                    'name'
                                );

                                if (response.data.state === 0) {
                                    $scope.videos.unshift(response.data.data);
                                } else {
                                    $root.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.video ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
                picture: function (node) {
                    if ($scope.picture && $scope.form.picture.$valid === true) {
                        groupFactory
                            .picture(node.id)
                            .upload({
                                name: $scope.picture.name,
                                photo: $scope.picture.base,
                            })
                            .then(function (response) {
                                if (response.data.state === 0) {
                                    groupFactory
                                        .picture(node.id)
                                        .attach(response.data.data.id, {})
                                        .then(function (response) {
                                            if (response.data.state === 0) {
                                                node.picture = response.data.data;
                                            }
                                        });
                                } else {
                                    $root.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.photo ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
                document: function (node) {
                    if ($scope.document && $scope.form.document.$valid === true) {
                        var fd = new FormData();
                        fd.append('document', $scope.document.file);
                        fd.append('name', $scope.document.name);

                        var document = $scope.document;
                        $scope.progress.documents.push({
                            name: document.name,
                        });

                        groupFactory
                            .documents(node.id)
                            .upload(fd, {
                                transformRequest: angular.identity,
                                headers: { 'Content-Type': undefined },
                            })
                            .then(function (response) {
                                $scope.progress.documents = $array.$splice(
                                    $scope.progress.documents,
                                    { name: document.name },
                                    'name'
                                );

                                if (response.data.state === 0) {
                                    if (response.data.data.updated) {
                                        $scope.replaceDocument(response.data.data);
                                    } else {
                                        $scope.documents.unshift(response.data.data);
                                    }
                                } else {
                                    $root.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.document ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
                documentReUpload: function (node) {
                    return new Promise(function (resolve, reject) {
                        if ($scope.document && $scope.form.document.$valid === true) {
                            var fd = new FormData();
                            fd.append('document', $scope.document.file);
                            fd.append('name', $scope.document.name);

                            var document = $scope.document;
                            $scope.progress.documents.push({
                                name: document.name,
                            });

                            groupFactory
                                .documents(node.id)
                                .upload(fd, {
                                    transformRequest: angular.identity,
                                    headers: { 'Content-Type': undefined },
                                })
                                .then(function (response) {
                                    $scope.progress.documents = $array.$splice(
                                        $scope.progress.documents,
                                        { name: document.name },
                                        'name'
                                    );

                                    if (response.data.state === 0) {
                                        $root.$broadcast('graph-modal-show', {
                                            title: 'Uploaded',
                                            content: 'Document was updated.',
                                        });
                                        resolve();
                                    } else {
                                        $root.$broadcast('graph-modal-show', {
                                            title: 'Error',
                                            content:
                                                response.data.data.document ||
                                                'The file is too large or the format is incorrect.',
                                        });
                                        reject();
                                    }
                                });
                        }
                    });
                },
            };

            $scope.replaceDocument = function (newDocument) {
                var index = null;
                $scope.documents.forEach(function (document, docIndex) {
                    if (newDocument.name === document.name && document.locked === true) {
                        index = docIndex;
                    }
                });

                $scope.documents.splice(index, 1);
                $scope.documents.splice(index, 0, newDocument);
            };

            function uploadAndAttachPhoto(groupEntry, file, attachFunc) {
                if (!groupEntry.id) {
                    return $q.reject('Passed Group object does not have an id prop');
                }

                if (!file) {
                    return $q.reject('File object not provided');
                }

                return groupFactory
                    .uploadGroupPhoto(groupEntry.id, {
                        name: file.name,
                        data64: file.base,
                    })
                    .then(attachFunc)
                    .catch(function () {
                        $root.$broadcast('graph-modal-show', {
                            title: 'Error',
                            content: 'The file is too large or the format is incorrect.',
                        });
                    });
            }

            function uploadHeaderImage(groupEntry, file) {
                uploadAndAttachPhoto(groupEntry, file, function (photoObj) {
                    return groupFactory.attachHeaderImage(groupEntry.id, photoObj.id);
                }).then(function (photoEntry) {
                    groupEntry.picture = photoEntry;
                });
            }

            $scope.delete = {
                photo: function (node, index) {
                    groupFactory
                        .photos($scope.node.id)
                        .delete(node.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                $scope.photos.splice(index, 1);
                            } else {
                                $root.$broadcast('graph-modal-show', {
                                    title: 'Error',
                                    content:
                                        response.data.data.photo ||
                                        'An error occurred in the remove. Please try again later',
                                });
                            }
                        });
                },
                video: function (node, index) {
                    groupFactory
                        .videos($scope.node.id)
                        .delete(node.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                $scope.videos.splice(index, 1);
                            } else {
                                $root.$broadcast('graph-modal-show', {
                                    title: 'Error',
                                    content:
                                        response.data.data.video ||
                                        'An error occurred in the remove. Please try again later',
                                });
                            }
                        });
                },
                document: function (node, index) {
                    groupFactory
                        .documents($scope.node.id)
                        .delete(node.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                $scope.documents.splice(index, 1);
                            } else {
                                $root.$broadcast('graph-modal-show', {
                                    title: 'Error',
                                    content:
                                        response.data.data.document ||
                                        'An error occurred in the remove. Please try again later',
                                });
                            }
                        });
                },
            };

            $socket.on('comment:create', function (data) {
                if (data.place.name === 'post') {
                    $scope.posts.forEach(function (node) {
                        if (parseInt(node.id) === parseInt(data.place.id)) {
                            ++node.comments;
                            if (!$scope.$$phase) {
                                $scope.$digest();
                            }
                        }
                    });
                }
            });

            $socket.on('comment:delete', function (data) {
                if (data.place.name === 'post') {
                    $scope.posts.forEach(function (node) {
                        if (parseInt(node.id) === parseInt(data.place.id)) {
                            --node.comments;
                            if (!$scope.$$phase) {
                                $scope.$digest();
                            }
                        }
                    });
                }
            });

            $scope.load = {
                timeline: function (next) {
                    ++$scope.params.timeline.page;
                    groupFactory
                        .news($scope.node.id)
                        .query({ params: $scope.params.timeline })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.posts = $scope.posts.concat(response.data.data);

                                $socket.emit(
                                    'join:post',
                                    response.data.data.map(function (item) {
                                        return item.id;
                                    })
                                );

                                if (next) next();
                            }
                        });
                },
                requests: function (next) {
                    $scope.Request.Query(next);
                },
                loadDocuments: function loadDocuments(pagination) {
                    // cancel previous request
                    canceler.resolve();
                    canceler = $q.defer();

                    $scope.params.documents.page = pagination.page;

                    return groupFactory
                        .documents($scope.node.id)
                        .query({
                            // pass pagination and filters
                            params: $scope.params.documents,
                            timeout: canceler.promise,
                        })
                        .then(function (response) {
                            $scope.documents = $scope.documents.concat(response.data.data);
                            // return pagination info for <load-more-button> component
                            return {
                                totalItems: response.data.total,
                                totalPages: response.data.pages,
                            };
                        });
                },
                documents: function (next) {
                    canceler.resolve();
                    canceler = $q.defer();

                    ++$scope.params.documents.page;
                    groupFactory
                        .documents($scope.node.id)
                        .query({
                            params: $scope.params.documents,
                            timeout: canceler.promise,
                        })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.documents = $scope.documents.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
                photos: function (next) {
                    ++$scope.params.photos.page;
                    groupFactory
                        .photos($scope.node.id)
                        .query({ params: $scope.params.photos })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.photos = $scope.photos.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
                videos: function (next) {
                    ++$scope.params.videos.page;
                    groupFactory
                        .videos($scope.node.id)
                        .query({ params: $scope.params.videos })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.videos = $scope.videos.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
            };

            $scope.filter.on.change = function () {
                $scroll.switch($scope.filter.tab());
            };

            $scope.$on('touch:timeline', function () {
                $scope.load.timeline();
            });

            $scope.$on('touch:video', function () {
                $scope.load.videos();
            });

            $scope.$on('touch:photo', function () {
                $scope.load.photos();
            });

            $scope.$on('touch:document', function () {
                $scope.documentsPagination = new $paginationFactory.paginate(function (params) {
                    return groupFactory
                        .documents($scope.node.id)
                        .query({ params: params })
                        .then(function (response) {
                            return {
                                items: response.data.data,
                                totalPages: response.data.pages,
                            };
                        });
                });

                /**
                 * @param {PaginateData} paginationData
                 */
                $scope.documentsPagination.onPageLoad = function (paginationData) {
                    $scope.documents = [].concat($scope.documents, paginationData.items);
                };

                $scope.documentsPagination.onReset = function () {
                    $scope.documents = [];
                };

                $scope.$on('document-filter-update', function ($e, queryFilters) {
                    $scope.documentsPagination.reset({ queryFilters: queryFilters });
                });
            });

            $scope.$on('touch:participant', function () {
                $scope.participants.Query();
            });

            $scope.$on('touch:request', function () {
                $scope.load.requests();
            });

            $scope.$on('$historyBack', $filter.init);

            $socket.on('post:create', function (message) {
                if (
                    $scope.posts
                        .map(function (item) {
                            return Number(item.id);
                        })
                        .indexOf(Number(message.node.id)) === -1
                ) {
                    if (message.place.name === 'group' && Number(message.place.id) === Number($scope.node.id)) {
                        $socket.emit('join:post', [message.node.id]);

                        if ($rootScope.me && message.node.owner.id === $rootScope.me.id) {
                            $scope.posts.unshift(message.node);

                            if (!$scope.$$phase) $scope.$digest();
                        } else {
                            $updates.appendUpdate(message.node);
                        }
                    }
                }
            });

            $scope.showUpdates = function () {
                return $updates.updatesQueue.length > 0;
            };

            $scope.cleanUpdates = function () {
                var updatesQueue = $updates.cleanUpdates();
                var defaultNodes = $scope.posts;
                $scope.posts = updatesQueue.concat(defaultNodes);
            };

            setTimeout(function () {
                window.scrollTo(0, 0);
            }, 2000);
        },
    ]);
